import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';
import { addImageFormatToCache } from './addImageFormatToCache';

export const saveNewFormat = async (imageId, formats, isGlobal) => {
  $('#saveNewFormat #editor-btn-spinner').show();
  const httpClient = await getAxiosClient();
  let table_name = '';
  if (isGlobal === true) {
    table_name = 'editor_backgrounds_default';
  } else {
    table_name = 'editor_backgrounds';
  }

  const url = `${process.env.PARSE_API_URL}/${table_name}/${imageId}`;
  const method = 'PUT';
  const data = {
    relations: [
      {
        column: 'formats',
        class: 'editor_project_formats_default',
        toIds: formats,
      },
    ],
  };
  try {
    await httpClient({ url, method, data: { data }, responseType: 'json' });
    addImageFormatToCache(imageId, formats);
    // displayImageManager(imageId);
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
